import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import CustomDateTimePicker from '@shared/component/DatePicker';
import TextInput from '@shared/component/TextInput';

// Create the CommonModal component
const OtherDemandView = (props: any) => {
    // State to manage the modal visibility
    const [show, setShow] = useState(props.showModel || true);

    const handleModel = flag => {
        setShow(flag);
        props.demanModelCallback(false);
    };

    const check = val => {
        const a =
            val?.sampleId != null
                ? val?.sampleId.split('.')[1] == 'jpeg' ||
                  val?.sampleId.split('.')[1] == 'jpg' ||
                  val?.sampleId.split('.')[1] == 'png'
                    ? process.env.REACT_APP_API_BASE + val.sampleId
                    : 'pdf'
                : null;
       
        return a;
    };

    return (
        <>
            {/* The Modal component */}
            <Modal
                scrollable={true}
                show={show}
                onHide={() => {
                    handleModel(false);
                }}
                backdrop="static"
                keyboard={false}
                size={'lg'}
            >
                <Modal.Header closeButton>
                    <Modal.Title> Demand Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="material_form_cover">
                        <form
                            onSubmit={e => {
                                e.preventDefault();
                            }}
                        >
                            <div className="field_box">
                                <h3>Bidding Type</h3>
                                <div className="check_field_box mb-4">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="flexRadioDefault1"
                                            value={'auto'}
                                            checked={props?.data?.demand?.bidType === 'auto'}
                                            disabled={true}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefault1">
                                            Auto
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="flexRadioDefault"
                                            id="flexRadioDefault2"
                                            value={'manual'}
                                            checked={props?.data?.demand?.bidType === 'manual'}
                                            disabled={true}
                                        />
                                        <label className="form-check-label" htmlFor="flexRadioDefault2">
                                            Manual
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="field_box">
                                <h3>Items & Vendor Details</h3>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'text',
                                                    placeholder: 'Select Category*',
                                                    name: 'quantity',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="quantity"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.category.name}
                                                setValue={e => {}}
                                                inputProps={{
                                                    quantity: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'text',
                                                    placeholder: 'Select Items*',
                                                    name: 'quantity',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="quantity"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.item.name}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    quantity: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'text',
                                                    placeholder: 'Enter Required Quantity',
                                                    name: 'quantity',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="quantity"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.quantity}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    quantity: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'text',
                                                    placeholder: 'Select Unit',
                                                    name: 'quantity',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="quantity"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.itemUnit}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    quantity: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            {/* <Multiselect
                                                    options={vendor}
                                                    selectedValues={formData.userIds || []}
                                                    onSelect={handlevendor}
                                                    onRemove={handlevendor}
                                                    displayValue="name"
                                                    placeholder='Select User'
                                                /> */}

                                            {/* <MultiSelect
                                                    ref={childRef}
                                                    options={vendor}
                                                    placeholder={'Select User*'}
                                                    getMultiSelectValue={getMultiSelectValue}
                                                    displayName="name"
                                                    displayValue="id"
                                                    notSelectDefault={true}
                                                    isClearable={edit ? false : true}
                                                    setSelectedValues={formData.userIds || null}
                                                /> */}

                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Select User',
                                                        name: 'quantity',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="quantity"
                                                    // isSubmit={isSubmit}
                                                    value={props?.data?.app_user?.name}
                                                    setValue={e => {
                                                        // console.log('e', e);
                                                    }}
                                                    inputProps={{
                                                        quantity: {
                                                            disabled: true,
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            {/* <CustomDateTimePicker
                                                data={{
                                                    name: 'deliveryDate',
                                                    placeholder: 'Select Delivery Date',
                                                    label: 'Delivery Date',
                                                    type: 'datetime-local',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="deliveryDate"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.deliveryDate}
                                                disabled={true}
                                            /> */}
                                            <CustomDateTimePicker
                                                data={{
                                                    name: 'cutOffTime',
                                                    placeholder: 'Select Cut-Off Date & Time',
                                                    label: 'Cut Off Date',
                                                    type: 'datetime-local',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="cutOffTime"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.cutOffTime}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'text',
                                                    placeholder: 'Enter Required Quality',
                                                    name: 'quality',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="quality"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.quality}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    quality: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>

                                   
                                    
                                    <div className="col-sm-12">
                                        <>
                                            {' '}
                                            {check(props?.data?.demand) != null ? (
                                                <>
                                                    <div className="field_box">
                                                        <h3>Attachment</h3>
                                                    </div>

                                                    {check(props?.data?.demand) == 'pdf' ? (
                                                        <>
                                                            <div className="previewpdf">
                                                                <a
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                    href={`${process.env.REACT_APP_API_BASE}${props?.data?.demand?.sampleId}`}
                                                                >
                                                                    <img
                                                                        src="./assets/images/pdficon.svg"
                                                                        className="img-fluid"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <span className="sm_info_text_box">Click To View</span>
                                                        </>
                                                    ) : (
                                                        <div className="previewimage">
                                                            <img
                                                                src={check(props?.data?.demand)}
                                                                className="img-fluid w-100 h-100"
                                                            />
                                                        </div>
                                                    )}
                                                    <br />
                                                </>
                                            ) : (
                                                ''
                                            )}
                                        </>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="field_box">
                                <h3>Additional Details</h3>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'text',
                                                    placeholder: 'Min Bid Rate (In Rs.)',
                                                    name: 'minBidRate',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="minBidRate"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.minBidRate}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    minBidRate: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-floating">
                                            <TextInput
                                                data={{
                                                    type: 'text',
                                                    placeholder: 'Max Bid Rate (In Rs.)',
                                                    name: 'minBidRate',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="minBidRate"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.maxBidRate}
                                                setValue={e => {
                                                    // console.log('e', e);
                                                }}
                                                inputProps={{
                                                    minBidRate: {
                                                        disabled: true,
                                                    },
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="form-floating">
                                            {/* <TextInput
                                                    data={{
                                                        type: 'datetime-local',
                                                        placeholder: 'Select Demand Cut-Off Date & Time',
                                                        name: 'cutOffTime',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="cutOffTime"
                                                    isSubmit={isSubmit}
                                                    value={
                                                        formData?.cutOffTime !== null
                                                            ? formData?.cutOffTime
                                                            : ''
                                                    }
                                                    setValue={(e: any) => getValue(e)}
                                                    errorMsg={errors?.cutOffTime.message}
                                                    inputProps={errors}
                                                /> */}
                                            {/* <CustomDateTimePicker
                                                data={{
                                                    name: 'cutOffTime',
                                                    placeholder: 'Select Cut-Off Date & Time',
                                                    label: 'Cut Off Date',
                                                    type: 'datetime-local',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="cutOffTime"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.cutOffTime}
                                                disabled={true}
                                            /> */}
                                            <CustomDateTimePicker
                                                data={{
                                                    name: 'deliveryDate',
                                                    placeholder: 'Select Delivery Date',
                                                    label: 'Delivery Date',
                                                    type: 'datetime-local',
                                                    id: 'floatingInput',
                                                }}
                                                controlName="deliveryDate"
                                                // isSubmit={isSubmit}
                                                value={props?.data?.demand?.deliveryDate}
                                                disabled={true}
                                            />
                                        </div>
                                    </div>

                                    {props?.data?.demand?.description && props?.data?.demand?.description != '' ? (
                                        <div className="col-sm-12">
                                            <div className="form-floating">
                                                <TextInput
                                                    data={{
                                                        type: 'text',
                                                        placeholder: 'Description',
                                                        name: 'description',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="description"
                                                    // isSubmit={isSubmit}
                                                    value={props?.data?.demand?.description}
                                                    setValue={e => {
                                                        // console.log('e', e);
                                                    }}
                                                    inputProps={{
                                                        description: {
                                                            disabled: true,
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default OtherDemandView;
